module.exports = __webpack_public_path__ + "static/media/arterite3.68e8fb5d.jpg";